import React, { useState } from "react";
import CmsPageBlock from "./CmsPageBlock";

const TYPES = [
    "CARD",
    "TEXT",
    "IMAGE",
    "DOCUMENT",
    "EMBED",
    "LINK",
    "HERO",
    "EVA_INTERACTION"
];

export default function CmsPageSection({section,index,onTitleChange,onAdd,onEdit,onWidth,onDelete,onDragStart,onDrop,onDragEnd,onMoveSection,onDeleteSection}) {
  const [showAdd,setShowAdd] = useState(false);
  return <section className="cms-editor-section" onDragOver={e=>e.preventDefault()} onDrop={e=>{e.preventDefault();onDrop(null)}}>
    <div className="cms-editor-section-heading">
      <div className="cms-editor-section-name"><span className="cms-editor-section-number">{String(index+1).padStart(2,"0")}</span><input aria-label="Section title" value={section.title} onChange={e=>onTitleChange(e.target.value)}/></div>
      <div className="cms-editor-section-tools"><button type="button" title="Move section up" onClick={()=>onMoveSection(-1)}>↑</button><button type="button" title="Move section down" onClick={()=>onMoveSection(1)}>↓</button><button type="button" onClick={()=>setShowAdd(!showAdd)}>+ Component</button><button type="button" title="Delete section" onClick={onDeleteSection}>×</button></div>
    </div>
    {showAdd && <div className="cms-editor-type-menu">{TYPES.map(type=><button type="button" key={type} onClick={()=>{onAdd(type);setShowAdd(false)}}>
	{
		type === "HERO" ? "Premium / Hero" :
		   type === "CARD" ? "Navigation card" :
		   type === "DOCUMENT" ? "SharePoint document" :
		   type === "EVA_INTERACTION" ? "Eva Interaction" :
		   type.charAt(0) + type.slice(1).toLowerCase()
	}
	</button>)}</div>}
    <div className="cms-editor-block-grid">
      {section.blocks.map(block=><CmsPageBlock key={block.id} block={block} onEdit={()=>onEdit(block.id)} onWidth={width=>onWidth(block.id,width)} onDelete={()=>onDelete(block.id)} onDragStart={()=>onDragStart(block.id)} onDragEnd={onDragEnd} onDrop={e=>{e.preventDefault();e.stopPropagation();onDrop(block.id)}}/>)}
      <button type="button" className="cms-editor-empty-block" onClick={()=>setShowAdd(true)}><span>+</span><small>Add component</small></button>
    </div>
  </section>;
}
